<template>
  <div class="form-group">
    <label v-if="label" class="form-label required">{{ label }}</label>

    <label class="custom-upload-area flex">
      <span class="upload-icon flex">
        <i class="fas fa-cloud-upload-alt"></i>
      </span>
      <div class="desc flex">
        <!-- <span>اسحب وأفلت مستندًا أو <mark>استعرضه</mark></span>
        <span class="upload-note">الحد الأقصى الموصى به 1600 ميجابايت والحد الأقصى 200 ميجابايت لكل ملف</span>
       -->
        <span v-html="Lang.get('messages.upload-drag-or-browse')"></span>
    <span class="upload-note">{{ Lang.get('messages.upload-note') }}</span>

    
    </div>
      <input
        type="file"
        ref="fileInput"
        hidden
        :multiple="multiple"
        :accept="filesTypes"
        @change="handleFileUpload"
      />
    </label>

    <div v-if="previewFile" class="file-preview mt-2">
      <img v-if="previewIsImage" :src="previewFile" style="max-width: 200px;" />
      <p v-else>تم رفع الملف بنجاح</p>
    </div>

    <small class="form-text text-danger" v-if="localErrors[name]" v-text="localErrors[name][0]" />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    name: { type: String, required: true },
    model: { type: Object, required: true },
    uploadApi: { type: String, required: true },
    filesTypes: {
      type: String,
      default: 'image/*,.pdf'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      localErrors: {},
      previewFile: null
    };
  },

  computed: {
    previewIsImage() {
      return this.previewFile && this.previewFile.startsWith('data:image');
    }
  },

  methods: {
    triggerFileDialog() {
      this.$refs.fileInput.click();
    },

// ...existing code...
async handleFileUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append(this.name, file);

  try {
    const response = await axios.post(this.uploadApi, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    // If you want to store as array (like OldFormUpload)
    if (!Array.isArray(this.model[this.name])) {
      this.model[this.name] = [];
    }
    this.model[this.name].push(response.data.id);

    this.localErrors = {};
    this.$emit('completed', response.data.id);

    // Show preview if image
    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewFile = e.target.result;
    };
    reader.readAsDataURL(file);
  } catch (error) {
    this.localErrors = error.response?.data?.errors || {};
    this.previewFile = null;
  } finally {
    this.$refs.fileInput.value = null;
  }
}
// ...existing code...
  },

  watch: {
    errors: {
      handler(newErrors) {
        this.localErrors = { ...newErrors };
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.custom-upload-area {
  border: 1px dashed var(--border-color);
  border-radius: var(--border-raduis);
  padding: 20px;
  gap: 10px;
  cursor: pointer;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-icon {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #f8f9fc;
  font-size: 20px;
  color: var(--green-color);
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-upload-area .desc {
  color: var(--black);
  font-size: 14px;
  gap: 10px;
  flex-direction: column;
  display: flex;
  text-align: center;
}
.custom-upload-area .desc mark {
  color: var(--green-color);
  background-color: transparent;
}
.upload-note {
  color: #939393;
  text-align: center;
  font-size: 12px;
}
.file-preview {
  margin-top: 10px;
}
</style>
